import React, { useEffect, useMemo, useState } from 'react'
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import PbUmkuService from '../../../../services/pbumku/PbumkuService'
import KapalService from '../../../../services/kapal/KapalService'
import { formatDateString, getCurrentDateFormatted, romanNum } from '../../../../utilities/Utils'
import { AsyncPaginate } from 'react-select-async-paginate'
import SweetAlert from 'react-bootstrap-sweetalert'
import UserService from '../../../../services/user/UserService'

const ModalSpt = ({ showSpt, handleCloseSpt, dataPpmKapal, dataDisposisi, reloadList, isEdit }) => {

    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    let kapalService = useMemo(() => new KapalService(), [])
    let userService = useMemo(() => new UserService(), [])

    const [nomorAgenda, setNomorAgenda] = useState(null)
    const [tanggalAgenda, setTanggalAgenda] = useState(getCurrentDateFormatted())
    const [loadAmbilNomor, setLoadAmbilNomor] = useState(false)
    const [disableBtnNomor, setDisableBtnNomor] = useState(false)
    const [valueTtdOpt, setValueTtdOpt] = useState(null)
    // const [valueTtdNama, setValueTtdNama] = useState(null)
    const [valueTtdJabatan, setValueTtdJabatan] = useState(null)
    const [valueTtdNip, setValueTtdNip] = useState(null)

    useEffect(() => {
        if (!dataPpmKapal) return
        const fetchAllData = async () => {
            try {
                const resSptKapal = await kapalService.getSptByAjuAndNomor(dataPpmKapal.nomorAjuKapal, dataDisposisi.noTugas)
                if (resSptKapal) {
                    setNomorAgenda(resSptKapal.data.nomorSpt)
                    setTanggalAgenda(formatDateString(resSptKapal.data.tanggalSpt))
                    setValueTtdJabatan(resSptKapal.data.jabtanTtd)

                    const resPegawai = await userService.getPegawaiById(resSptKapal.data.pejabatTtd)
                    let optPegawai = { nipPenandatangan: resPegawai.data.nip, namaPenandatangan: resPegawai.data.nama }
                    setValueTtdOpt(optPegawai)
                }
            } catch (error) {

            }
        }
        fetchAllData()
    }, [pbumkuService, kapalService, dataPpmKapal, dataDisposisi, userService])

    const handleClickAmbilNomor = async () => {
        try {
            setLoadAmbilNomor(true)
            const resp = await pbumkuService.ambilNomorService('SPT_KAPAL', 'KP', currentYear, localStorage.getItem("username"))
            setNomorAgenda(resp.data.kodePusat + '-' + resp.data.nomorUrut + '/' + resp.data.uraianPusat + '/' + romanNum(currentMonth) + '/' + currentYear)
            setLoadAmbilNomor(false)
            setDisableBtnNomor(true)
        } catch (error) {
            console.log(error)
        }
    }

    async function loadOptionPenandatangan(search, loadedOption, { page = 1 }) {
        const response = await pbumkuService.listPenandatangan(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangePenandatangan = e => {
        setValueTtdOpt(e)
        // setValueTtdNama(e.namaPenandatangan)
        setValueTtdJabatan(e.jabatanPenandatangan)
        setValueTtdNip(e.nipPenandatangan)
    }

    const onChangeTanggalAgenda = e => {
        setTanggalAgenda(e.target.value)
    }

    const [showConfirmSave, setShowConfirmSave] = useState(false)
    const handleCloseConfirmSave = () => setShowConfirmSave(false)
    const handleClickConfirmSave = () => {
        setShowConfirmSave(true)
    }
    const [loadingSave, setLoadingSave] = useState(false)
    const [showSaveSuccess, setShowSaveSucces] = useState(false)
    const [showSaveFailed, setShowSaveFailed] = useState(false)

    const handleClickSave = async () => {
        setLoadingSave(true)
        try {
            let jsonSpt = {
                nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                nomorSpt: nomorAgenda,
                tanggalSpt: tanggalAgenda,
                kdUpt: dataPpmKapal.kodeUpt,
                pejabatTtd: valueTtdNip,
                jabtanTtd: valueTtdJabatan,
                createdBy: localStorage.getItem('userId'),
                createdDate: new Date(),
                namaIzin: 'CPIB Kapal',
                stsTte: 0
            }
            const resSpt = await kapalService.saveSptKapal(jsonSpt)
            if (resSpt.data.kode === '200') {
                let dataDispo = {
                    ...dataDisposisi,
                    noTugas: nomorAgenda,
                    tglTugas: tanggalAgenda,
                }
                await kapalService.savePenugasan(dataDispo)

                //ST
                // let jsonDisposisiNext = {
                //     nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                //     idDisposisi: 2,
                //     createdBy: localStorage.getItem('userId'),
                //     createdDate: new Date()
                // }
                // await kapalService.savePenugasan(jsonDisposisiNext)

                //Tindak Lanjut SP
                let jsonDisposisiNext = {
                    nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                    idDisposisi: 19,
                    createdBy: localStorage.getItem('userId'),
                    createdDate: new Date()
                }
                await kapalService.savePenugasan(jsonDisposisiNext)

                //ST
                // let jsonStatus = {
                //     nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                //     kodeStatus: '021',
                //     waktuStatus: new Date(),
                //     createdBy: localStorage.getItem("userId"),
                //     createdAt: new Date()
                // }
                //Tindak Lanjut SP
                let jsonStatus = {
                    nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                    kodeStatus: '050',
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem("userId"),
                    createdAt: new Date()
                }

                await kapalService.saveKapalStatus(jsonStatus)

                // let jsonKapal = {
                //     ...dataPpmKapal,
                //     kodeStatus: '021',
                // }
                let jsonKapal = {
                    ...dataPpmKapal,
                    kodeStatus: '050',
                    updatedBy: localStorage.getItem('userId'),
                    updatedDate: new Date()
                }
                await kapalService.saveKapalHeader(jsonKapal)

                setShowConfirmSave(false)
                setShowSaveSucces(true)
            }
        } catch (error) {
            setShowConfirmSave(false)
            setShowSaveFailed(true)
        }
        setLoadingSave(false)
    }

    const handleClickSaveSuccess = () => {
        setShowSaveSucces(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleClickSaveFailed = () => {
        setShowSaveFailed(false)
    }

    return (
        <>
            <Modal
                show={showSpt}
                onHide={handleCloseSpt}
                size='lg'
                centered
            >
                <Modal.Header>
                    <Modal.Title><h5>Surat Perintah Inspeksi</h5></Modal.Title>
                    {localStorage.getItem("role") !== "6" && <span className='text-danger'>Akun UPT Tidak Diperkenankan Proses SPT</span>}
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju</Form.Label>
                                    <Col sm="4">
                                        <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={dataPpmKapal.nomorAjuKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Kapal</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.namaKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Ukuran Kapal</Form.Label>
                                    <Col sm="3">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.ukuranKapal} disabled />
                                    </Col>
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">GT</Form.Label>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor SPT</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-8 form-control-sm" name="nomor_spt" value={nomorAgenda} disabled />{' '}
                            {isEdit && <Button variant="secondary" size="sm" onClick={() => handleClickAmbilNomor()} disabled={disableBtnNomor}>Ambil Nomor {loadAmbilNomor && <Spinner />}</Button>}{' '}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Tanggal SPT</label>
                        <div className="col-sm-4">
                            <input type="date" className="col-sm-12 form-control-sm" name="tanggal_spt" onChange={onChangeTanggalAgenda} value={tanggalAgenda} />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Penandatangan</Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionPenandatangan}
                                            value={valueTtdOpt}
                                            getOptionValue={(option) => option.namaPenandatangan}
                                            getOptionLabel={(option) => option.namaPenandatangan}
                                            additional={{
                                                page: 0
                                            }}
                                            onChange={onChangePenandatangan}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Jabatan</label>
                        <div className="col-sm-10">
                            <input type="text" className="col-sm-12 form-control-sm" name="jabatan_ttd" value={valueTtdJabatan} disabled />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && localStorage.getItem("role") === "6" && <Button variant="primary" size="sm" onClick={() => handleClickConfirmSave()}>Proses</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseSpt}>Batal</Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmSave &&
                <SweetAlert
                    title="Proses SPT?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSave}
                    onCancel={handleCloseConfirmSave}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                    reverseButtons
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSaveSuccess &&
                <SweetAlert
                    success
                    title="Simpan SPT Berhasil"
                    onConfirm={handleClickSaveSuccess}
                    btnSize="sm"
                />
            }
            {
                showSaveFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Gagal"
                    onConfirm={handleClickSaveFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalSpt